/**
 * React Native WebView와 통신하기 위한 유틸리티
 */

import type { AuthUser } from "@growing/types";

interface ReactNativeWebView {
  postMessage(message: string): void;
}

declare global {
  interface Window {
    ReactNativeWebView?: ReactNativeWebView;
  }
}

/**
 * React Native WebView 환경인지 확인
 */
export function isInApp(): boolean {
  return typeof window !== "undefined" && !!window.ReactNativeWebView;
}

/**
 * 앱으로 메시지 전송
 */
export function sendMessageToApp(data: Record<string, unknown>): void {
  if (isInApp()) {
    window.ReactNativeWebView?.postMessage(JSON.stringify(data));
  }
}

/**
 * 앱에 현재 경로 전달 (탭 전환용)
 */
export function notifyAppNavigation(path: string): void {
  sendMessageToApp({
    type: "NAVIGATE",
    path,
  });
}

/**
 * 앱바 타이틀 설정
 */
export function setAppBarTitle(title: string): void {
  sendMessageToApp({
    type: "SET_TITLE",
    title,
  });
}

/**
 * 앱으로 로그아웃 알림
 */
export function notifyAppLogout(): void {
  sendMessageToApp({
    type: "LOGOUT",
  });
}

/**
 * 앱으로 로그인 토큰 전달
 */
export function notifyAppLogin(token: string, user: AuthUser): void {
  sendMessageToApp({
    type: "SAVE_TOKEN",
    token,
    user,
  });
}

/**
 * 앱에 화면 전환 요청 (이미 로그인된 경우)
 */
export function requestAppScreenChange(screen: "/main" | "/auth"): void {
  sendMessageToApp({
    type: "CHANGE_SCREEN",
    screen,
  });
}
